import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import { hideLoader, showLoader } from "./loaderSlice";
import { showToast } from "./toastSlice";

const initialState = {
  messages: [],
  isTyping: false,
};

export const sendMessageAction = createAsyncThunk(
  "ai/sendMessage",
  async (message, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "post",
        Constants.END_POINT.ai_chat,
        { message }
      );
      if (res?.success && res?.data) {
        return res.data;
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: "Failed to get AI response" }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

const aiSlice = createSlice({
  name: "ai",
  initialState,
  reducers: {
    addMessage: (state, action) => {
      // If it's a typing indicator, remove any existing typing indicators first
      if (action.payload.isTyping) {
        state.messages = state.messages.filter(msg => !msg.isTyping);
      }
      state.messages.push(action.payload);
    },
    removeTypingIndicators: (state) => {
      state.messages = state.messages.filter(msg => !msg.isTyping);
    },
    clearMessages: (state) => {
      state.messages = [];
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessageAction.fulfilled, (state, action) => {
        // Remove typing indicators when we get a response
        state.messages = state.messages.filter(msg => !msg.isTyping);
      })
      .addCase(sendMessageAction.rejected, (state) => {
        // Remove typing indicators on error
        state.messages = state.messages.filter(msg => !msg.isTyping);
      });
  },
});

export const { addMessage, removeTypingIndicators, clearMessages, setMessages } = aiSlice.actions;

export default aiSlice.reducer;
